import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class DriveIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="60" height="57" viewBox="0 0 60 57"><g fillRule="nonzero" fill="none"><path fill="#FFF" d="M38.616 3.702C35.188 1.278 31.22 0 27.14 0H11v39.953h16.141c3.169 0 6.322-.76 9.122-2.212a20.187 20.187 0 0 0 6.917-5.89A19.781 19.781 0 0 0 47.094 20a19.995 19.995 0 0 0-8.478-16.298z"/><path fill="#0A72BA" d="M38.859 20c0 2.243-.635 4.337-1.734 6.125l4.793 4.793A18.244 18.244 0 0 0 45.518 20c0-6.204-3.09-11.686-7.804-15.02l-4.816 4.824c3.553 2.008 5.96 5.827 5.96 10.196z"/><path fill="#F5C029" d="M19.282 8.314h.032l-6.745-6.745v28.556l6.713-6.713z"/><path fill="#40B75F" d="M37.125 26.125c-2.062 3.35-5.764 5.593-9.984 5.593-.572 0-5.678-.008-7.859-.032v-8.274l-6.713 6.713v8.251H27.14c6.047 0 11.428-2.94 14.777-7.466l-4.793-4.785z"/><path fill="#E02834" d="M27.141 8.282c2.094 0 4.055.557 5.757 1.514l4.816-4.816C34.718 2.87 31.07 1.57 27.14 1.57H12.57l6.745 6.745c2.196-.024 7.262-.032 7.827-.032z"/><path fill="#F4B627" d="M22.82 10.831v18.29l12.094-8.619a.638.638 0 0 0 0-1.043L22.82 10.83z"/><path fill="#F5C029" d="M22.82 10.831v18.29l10.556-9.897a.585.585 0 0 0-.062-.91L22.82 10.83z"/></g></svg>
        )
    }
}

export default withCssClassName(DriveIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/drive-icon.js